export default __webpack_public_path__ + "static/media/vkpic7.d95387ff.png";